export enum ChangeNames {
    INVOICE_RECIPIENT = "invoiceRecipient",
    PROPERTY_OWNER = "propertyOwner",
    APPLICANT = "applicant",
    SYSTEM_CONSTRUCTOR = "systemConstructor",
    ADDITIONAL_NOTES = "additionalNotes",
    BUILDING_ADDRESS = "buildingAddress",
    PRODUCT_TYPES = "productTypes", // neuanschluss
    PRODUCT_CLASSES = "productClasses", // gas, strom
    ADJUSTABLE_LOAD_TYPES = "adjustableLoadTypes",
    MODIFICATION_BUILDING_USAGES = "modificationBuildingUsages",
    MODIFICATION_HOUSING_UNITS = "modificationHousingUnits",
    MODIFICATION_GAS_RELOCATION_DISTANCE = "modificationGasRelocationDistance",
    MODIFICATION_POWER_CABLE = "modificationPowerCable",
    MODIFICATION_POWER_CABLE_JUNCTION_BOX_RELOCATION_DISTANCE = "modificationPowerCableJunctionBoxRelocationDistance",
    MODIFICATION_POWER_CABLE_RELOCATION_DISTANCE = "modificationPowerCableRelocationDistance",
    MODIFICATION_POWER_FEEDS = "modificationPowerFeeds",
    MODIFICATION_ELECTRIC_BUSINESS_DEMAND = "modificationElectricBusinessDemand",
    MODIFICATION_POWER_JUNCTION_BOX_REPLACEMENT_REASON = "modificationPowerJunctionBoxReplacementReason",
    MODIFICATION_POWER_OVERHEAD = "modificationPowerOverhead",
    MODIFICATION_POWER_OVERHEAD_ROOF_PILLAR_REASSEMBLY_LOCATION = "modificationPowerOverheadRoofPillarReassemblyLocation",
    MODIFICATION_REASON = "modificationReason",
    NEW_CONNECTION_BUILDING_INTAKES = "newConnectionBuildingIntakes",
    NEW_CONNECTION_BUILDING_TYPES = "newConnectionBuildingTypes",
    NEW_CONNECTION_BUILDING_USAGES = "newConnectionBuildingUsages",
    NEW_CONNECTION_CELLAR = "newConnectionCellar",
    MODIFICATION_CELLAR = "modificationCellar",
    NEW_CONNECTION_ELECTRIC_BOILER = "newConnectionElectricBoiler",
    NEW_CONNECTION_ELECTRIC_BUSINESS_DEMAND = "newConnectionElectricBusinessDemand",
    NEW_CONNECTION_ELECTRIC_ELEVATOR = "newConnectionElectricElevator",
    NEW_CONNECTION_ELECTRIC_SHARED_ELECTRICITY = "newConnectionElectricSharedElectricity",
    NEW_CONNECTION_ELECTRIC_SAUNA = "newConnectionElectricSauna",
    NEW_CONNECTION_ELECTRIC_HEAT_PUMP = "newConnectionElectricHeatPump",
    NEW_CONNECTION_ELECTRIC_HEAT_PUMP_V2 = "newConnectionElectricHeatPumpV2",
    NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM = "newConnectionElectricHeatingSystem",
    NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM_V2 = "newConnectionElectricHeatingSystemV2",
    NEW_CONNECTION_ELECTRIC_ROOM_COOLING_DEVICE = "newConnectionElectricRoomCoolingDevice",
    NEW_CONNECTION_ELECTRIC_INFEED = "newConnectionElectricInfeed",
    NEW_CONNECTION_ELECTRIC_LOADER = "newConnectionElectricLoader",
    NEW_CONNECTION_ELECTRIC_LOADER_V2 = "newConnectionElectricLoaderV2",
    NEW_CONNECTION_ELECTRIC_MISCELLANEOUS = "newConnectionElectricMiscellaneous",
    NEW_CONNECTION_EXTERIOR_TYPES = "newConnectionExteriorTypes",
    NEW_CONNECTION_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR = "newConnectionConnectionPillarDeliveredBySystemOperator",
    NEW_CONNECTION_GAS_FEEDS = "newConnectionGasFeeds",
    NEW_CONNECTION_GAS_DEMAND = "newConnectionGasDemand",
    NEW_CONNECTION_HOUSING_UNITS = "newConnectionHousingUnits",
    NEW_CONNECTION_MULTILINE_BASE_PLATE_HEIGHT = "newConnectionMultilineBasePlateHeight",
    NEW_CONNECTION_MULTILINE_BUILDING_INTAKE_SPECIFICATION = "newConnectionMultilineBuildingIntakeSpecification",
    NEW_CONNECTION_MULTILINE_CELLAR_CASING_PIPE_DELIVERED_BY_DISTRIBUTION_SYSTEM_OPERATOR = "newConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator",
    NEW_CONNECTION_MULTILINE_CELLAR_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR = "newConnectionMultilineCellarInstallationFrameInstalledByDistributionSystemOperator",
    NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL = "newConnectionMultilineCellarOuterWall",
    NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL_BUSHING = "newConnectionMultilineCellarOuterWallBushing",
    NEW_CONNECTION_MULTILINE_CONTACT_ALLOWED = "newConnectionMultilineContactAllowed",
    NEW_CONNECTION_MULTILINE_DESIRES = "newConnectionMultilineDesires",
    NEW_CONNECTION_MULTILINE_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR = "newConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator",
    NEW_CONNECTION_MULTILINE_VARIANTS = "newConnectionMultilineVariants",
    NEW_CONNECTION_POWER_FEEDS = "newConnectionPowerFeeds",
    NEW_CONNECTION_ROOF_TYPES = "newConnectionRoofTypes",

    REMOVAL_RECONSTRUCTION_BUILDING_USAGES = "removalReconstructionBuildingUsages",
    REMOVAL_RECONSTRUCTION_HOUSING_UNITS = "removalReconstructionHousingUnits",
    MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING = "modificationPersonalContributionCanDoWallBushing",
    MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK = "modificationPersonalContributionCanDoUndergroundWork",

    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK = "newConnectionMultilinePersonalContributionCanDoUndergroundWork",
    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING = "newConnectionMultilinePersonalContributionCanDoWallBushing",
    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_UNDERGROUND_WORK = "newConnectionMultilinePersonalContributionMustDoUndergroundWork",
    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_WALL_BUSHING = "newConnectionMultilinePersonalContributionMustDoWallBushing",
    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_OWN_INSTALLATION_FRAME = "newConnectionMultilinePersonalContributionMustInfuseOwnInstallationFrame",
    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_PROVIDED_INSTALLATION_FRAME = "newConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrame",
    NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INSTALL_CASING_PIPE = "newConnectionMultilinePersonalContributionMustInstallCasingPipe",
    NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK = "newConnectionPersonalContributionCanDoUndergroundWork",
    NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING = "newConnectionPersonalContributionCanDoWallBushing",
    NEW_CONNECTION_PERSONAL_CONTRIBUTION_MUST_DO_BASE_PLATE_BUSHING = "newConnectionPersonalContributionMustDoBasePlateBushing",
    NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_BASE_PLATE_BUSHING = "newConnectionPersonalContributionCanDoBasePlateBushing",
    REMOVAL_BUILDING_OCCUPATION_CONFIRMATION = "removalBuildingOccupationConfirmation",
    REMOVAL_POWER_SUBJECT = "removalPowerSubject",
    REMOVAL_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK = "removalPersonalContributionCanDoUndergroundWork",
    REMOVAL_RECONSTRUCTION = "removalReconstruction",
    REMOVAL_RECONSTRUCTION_PRODUCT_CLASSES = "removalReconstructionProductClasses",
    REMOVAL_DATE = "removalDate",
    REMOVAL_RECONSTRUCTION_DATE = "removalReconstructionDate",

    CHARGER_LOCATION = "chargerLocations",
    CHARGER_PUBLIC_PARKING_USAGES = "chargerPublicParkingUsages",
    CHARGER_PRIVATE_PARKING_USAGES = "chargerPrivateParkingUsages",
    CHARGER_SUPPLY_CONNECTION = "chargerSupplyConnection",
    CHARGER_CONNECTION_EXTERIOR_TYPE = "chargerConnectionExteriorTypes",
    CHARGER_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR = "chargerConnectionPillarDeliveredBySystemOperator",
    CHARGER_ADDITIONAL_ELECTRIC_DEMAND = "chargerAdditionalElectricDemand",
    CHARGER_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK = "chargerPersonalContributionCanDoUndergroundWork",
    ADJUSTABLE_LOAD_BUILDING_USAGE = "adjustableLoadBuildingUsages",
    ADJUSTABLE_LOAD_HOUSING_UNITS = "adjustableLoadHousingUnits",
    ADJUSTABLE_LOAD_ELECTRICAL_BUSINESS_DEMAND = "adjustableLoadElectricBusinessDemand",
    ADJUSTABLE_LOAD_ELECTRICAL_BOILER = "adjustableLoadElectricBoiler",
    ADJUSTABLE_LOAD_ELECTRICAL_HEAT_PUMP = "adjustableLoadElectricHeatPump",
    ADJUSTABLE_LOAD_ELECTRICAL_ELEVATOR = "adjustableLoadElectricElevator",
    ADJUSTABLE_LOAD_ELECTRIC_LOADER = "adjustableLoadElectricLoader",
    ADJUSTABLE_LOAD_ELECTRIC_SHARED_ELECTRICITY = "adjustableLoadElectricSharedElectricity",
    ADJUSTABLE_LOAD_ELECTRIC_SAUNA = "adjustableLoadElectricSauna",
    ADJUSTABLE_LOAD_ELECTRIC_MISCELLANEOUS = "adjustableLoadElectricMiscellaneous",
    ADJUSTABLE_LOAD_HOUSE_CONNECTION_FUSE_CAPACITY = "adjustableLoadHouseConnectionFuseCapacity",
    ADJUSTABLE_LOAD_ELECTRIC_INSTALLATION_AGREEMENT = "adjustableLoadElectricInstallationAgreement",
    CHARGER_BUILDING_USAGE = "chargerBuildingUsages",
    CHARGER_HOUSING_UNITS = "chargerHousingUnits",
    CHARGER_ELECTRICAL_BUSINESS_DEMAND = "chargerElectricBusinessDemand",
    CHARGER_ELECTRICAL_BOILER = "chargerElectricBoiler",
    CHARGER_ELECTRICAL_HEAT_PUMP = "chargerElectricHeatPump",
    CHARGER_ELECTRICAL_ELEVATOR = "chargerElectricElevator",
    CHARGER_ELECTRIC_LOADER = "chargerElectricLoader",
    CHARGER_ELECTRIC_SHARED_ELECTRICITY = "chargerElectricSharedElectricity",
    CHARGER_ELECTRIC_SAUNA = "chargerElectricSauna",
    CHARGER_ELECTRIC_MISCELLANEOUS = "chargerElectricMiscellaneous",
    CHARGER_HOUSE_CONNECTION_FUSE_CAPACITY = "chargerHouseConnectionFuseCapacity",
    ADJUSTABLE_LOAD_DATA_SHEET_DOWNLOAD = "adjustableLoadDataSheetDownload",
    CHARGER_CHARGING_STATIONS = "chargerChargingStations",
    CHARGER_LOAD_MANAGEMENT = "chargerLoadManagement",
    CHARGER_ELECTRIC_INSTALLATION_AGREEMENT = "chargerElectricInstallationAgreement",

    INCREASE_BUILDING_USAGES = "increaseBuildingUsages",
    INCREASE_CURRENT_HOUSING_UNITS = "increaseCurrentHousingUnits",
    INCREASE_CURRENT_ELECTRIC_BUSINESS_DEMAND = "increaseCurrentElectricBusinessDemand",
    INCREASE_CURRENT_ELECTRIC_BOILER = "increaseCurrentElectricBoiler",
    INCREASE_CURRENT_ELECTRIC_HEAT_PUMP = "increaseCurrentElectricHeatPump",
    INCREASE_CURRENT_ELECTRIC_ELEVATOR = "increaseCurrentElectricElevator",
    INCREASE_CURRENT_ELECTRIC_LOADER = "increaseCurrentElectricLoader",
    INCREASE_CURRENT_ELECTRIC_SHARED_ELECTRICITY = "increaseCurrentElectricSharedElectricity",
    INCREASE_CURRENT_ELECTRIC_SAUNA = "increaseCurrentElectricSauna",
    INCREASE_CURRENT_ELECTRIC_MISCELLANEOUS = "increaseCurrentElectricMiscellaneous",
    INCREASE_CURRENT_GAS_DEMAND = "increaseCurrentGasDemand",
    INCREASE_CURRENT_HOUSE_CONNECTION_FUSE_CAPACITY = "increaseCurrentHouseConnectionFuseCapacity",

    INCREASE_EXPECTED_GAS_DEMAND = "increaseExpectedGasDemand",
    INCREASE_EXPECTED_HOUSING_UNITS = "increaseExpectedHousingUnits",
    INCREASE_EXPECTED_ELECTRIC_BUSINESS_DEMAND = "increaseExpectedElectricBusinessDemand",
    INCREASE_EXPECTED_ELECTRIC_BOILER = "increaseExpectedElectricBoiler",
    INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP = "increaseExpectedElectricHeatPump",
    INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP_V2 = "increaseExpectedElectricHeatPumpV2",
    INCREASE_EXPECTED_ELECTRIC_HEATING_SYSTEM = "increaseExpectedElectricHeatingSystem",
    INCREASE_EXPECTED_ELECTRIC_ROOM_COOLING_DEVICE = "increaseExpectedElectricRoomCoolingDevice",
    INCREASE_EXPECTED_ELECTRIC_ELEVATOR = "increaseExpectedElectricElevator",
    INCREASE_EXPECTED_ELECTRIC_LOADER = "increaseExpectedElectricLoader",
    INCREASE_EXPECTED_ELECTRIC_LOADER_V2 = "increaseExpectedElectricLoaderV2",
    INCREASE_EXPECTED_ELECTRIC_SHARED_ELECTRICITY = "increaseExpectedElectricSharedElectricity",
    INCREASE_EXPECTED_ELECTRIC_SAUNA = "increaseExpectedElectricSauna",
    INCREASE_EXPECTED_ELECTRIC_MISCELLANEOUS = "increaseExpectedElectricMiscellaneous",
    INCREASE_ADDITIONAL_NOTES = "increaseAdditionalNotes",

    DATA_PROTECTION_AGREEMENT = "dataProtectionAgreement",
    TERMS_OF_USE_AGREEMENT = "termsOfUseAgreement",
    ADJUSTABLE_LOAD_AGREEMENT = "adjustableLoadAgreement",
}

export enum ErrorTypes {
    UNKNOWN_VALUE = "UNKNOWN_VALUE",
    NEGATIVE_VALUE = "NEGATIVE_VALUE",
}

export type DocumentState =
    | {
          relevant: false;
          order: number;
          files: [];
      }
    | {
          relevant: true;
          optional: boolean;
          title: string;
          description: string;
          files: {
              bucketId: string;
              objectId: string;
              contentType: string;
              extension: string;
              size: number;
              createdAt: number;
              userFilename: string;
          }[];
          progress?: number;
          error?: Error;
          order: number;
      };

export type DocumentCollection = {
    [classification: string]: DocumentState;
};

export const DOCUMENT_NONE = "NO_DOCUMENT";
export const DOCUMENT_UPLOADED = "UPLOADED_DOCUMENT";
export const DOCUMENT_ERROR = "DOCUMENT_ERROR";
export const DOCUMENT_PROGRESS = "DOCUMENT_PROGRESS";
export interface DocumentNone {
    state: typeof DOCUMENT_NONE;
}
export interface DocumentUploaded {
    state: typeof DOCUMENT_UPLOADED;
    uuid: string;
    classification: string;
    userFilename: string;
    configurationId: string;
    mimeType: string;
    fileSize: number;
    downloadUrl: string;
}
export interface DocumentProgress {
    state: typeof DOCUMENT_PROGRESS;
    uuid: string;
    classification: string;
    progress: number;
    userFilename: string;
    configurationId: string;
    mimeType: string;
    fileSize: number;
}

export interface DocumentError {
    state: typeof DOCUMENT_ERROR;
    uuid: string;
    classification: string;
    configurationId: string;
    error: Error;
}

export type Order = {
    id: string;
    configurationId: string;
    createdAt: number;
    updatedAt: number;
    crm?: {
        id: string;
        processedAt: number;
    };
    summary?: {
        bucketId: string;
        objectId: string;
    };
};

export type Address = {
    street: StateValue<string>;
    houseNumber: StateValue<string>;
    zipCode: StateValue<string>;
    city: StateValue<string>;
    district?: StateValue<string | null>;
};

export type Change<N extends keyof ChangeTypes = any> = {
    relevant: boolean;
    default: boolean;
    state: ChangeTypes[N];
};

export type StateValue<T = any> = {
    value: T;
    error?: ErrorTypes | null;
};

function isStateValue(s: any): s is StateValue {
    return !!(s && s["value"] !== undefined);
}

export type DemandValue = {
    amount: number | null;
    unit: string;
    precision: number;
};

export type BoxedDemandValue = {
    amount: DoubleBox;
    unit: string;
    precision: number;
};

export type BoxedAndKnowableDemandValue = {
    notKnown: boolean;
    amount: DoubleBox;
    unit: string;
    precision: number;
};

export type YesNo = {
    yes: boolean;
    no: boolean;
};
export type HousingUnits = {
    units: number | null;
};
export type InstalledHousingUnits = {
    installed: boolean;
    units: number | null;
};
export type DoubleBox = {
    num: number | null;
};
export type StringBox = {
    text: string | null;
};

function isDemandValue(s: any): s is DemandValue {
    return !!(s && s["unit"] !== undefined && s["precision"] !== undefined);
}

function isBoxedDemandValue(s: any): s is BoxedDemandValue {
    return !!(
        s &&
        s["amount"] &&
        s["amount"]["num"] !== undefined &&
        s["unit"] !== undefined &&
        s["precision"] !== undefined &&
        s["notKnown"] === undefined
    );
}

function isBoxedAndKnowableDemandValue(s: any): s is BoxedAndKnowableDemandValue {
    return !!(
        s &&
        s["amount"] &&
        s["amount"]["num"] !== undefined &&
        s["unit"] !== undefined &&
        s["precision"] !== undefined &&
        s["notKnown"] !== undefined
    );
}

export const typePostal = "postal";
export const typeCadaster = "cadaster";

export type PostalAddress = {
    type: typeof typePostal;
    city: StateValue<string>;
    street: StateValue<string>;
    houseNumber: StateValue<string>;
    zipCode: StateValue<string>;
    district?: StateValue<string | null>;
};

export type CadasterAddress = {
    type: typeof typeCadaster;
    city: StateValue<string>;
    street?: StateValue<string | null>;
    houseNumber?: StateValue<string | null>;
    zipCode: StateValue<string>;
    district?: StateValue<string | null>;
    mark: StateValue<string>;
    parcel: StateValue<string>;
    corridor?: StateValue<string | null>;
};

export type NaturalPerson = {
    firstName: StateValue<string>;
    lastName: StateValue<string>;
    address: Address;
    phoneNumber: StateValue<string | null>;
    email: StateValue<string | null>;
};

export type LegalPerson = {
    name: StateValue<string>;
    address: Address;
    phoneNumber: StateValue<string | null>;
    email: StateValue<string | null>;
};

export type ChangeTypes = {
    [ChangeNames.ADDITIONAL_NOTES]: StateValue<StringBox>;
    [ChangeNames.INVOICE_RECIPIENT]: StateValue<{
        salutation: {
            mr: boolean;
            ms: boolean;
            diverse: boolean;
            family: boolean;
            spouses: boolean;
            company: boolean;
            flatSharingCommunity: boolean;
            buildingOwnerAssociation: boolean;
            heirCommunity: boolean;
            publicOfficials: boolean;
        };
        natural?: NaturalPerson;
        legal?: LegalPerson;
    }>;
    [ChangeNames.PROPERTY_OWNER]: StateValue<{
        equalToInvoiceRecipient: boolean;
        partner: {
            salutation: {
                mr: boolean;
                ms: boolean;
                diverse: boolean;
                family: boolean;
                spouses: boolean;
                company: boolean;
                flatSharingCommunity: boolean;
                buildingOwnerAssociation: boolean;
                heirCommunity: boolean;
                publicOfficials: boolean;
            };
            natural?: NaturalPerson;
            legal?: LegalPerson;
        };
    }>;
    [ChangeNames.APPLICANT]: StateValue<{
        equalToInvoiceRecipient: boolean;
        partner: {
            salutation: {
                mr: boolean;
                ms: boolean;
                diverse: boolean;
                family: boolean;
                spouses: boolean;
                company: boolean;
                flatSharingCommunity: boolean;
                buildingOwnerAssociation: boolean;
                heirCommunity: boolean;
                publicOfficials: boolean;
            };
            natural?: NaturalPerson;
            legal?: LegalPerson;
        };
    }>;
    [ChangeNames.SYSTEM_CONSTRUCTOR]: StateValue<{
        salutation: {
            company: boolean;
            flatSharingCommunity: boolean;
            buildingOwnerAssociation: boolean;
            heirCommunity: boolean;
            publicOfficials: boolean;
        };
        legal: LegalPerson;
    }>;
    [ChangeNames.BUILDING_ADDRESS]: PostalAddress | CadasterAddress;
    [ChangeNames.PRODUCT_TYPES]: StateValue<{
        newConnection: boolean;
        modification: boolean;
        removal: boolean;
        charger?: boolean;
        increase: boolean;
        adjustableLoad: boolean;
    }>;
    [ChangeNames.PRODUCT_CLASSES]: StateValue<{
        power: boolean;
        gas: boolean;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_TYPES]: StateValue<{
        charger: boolean;
        heatPump: boolean;
        roomCoolingDevice: boolean;
    }>;

    [ChangeNames.MODIFICATION_BUILDING_USAGES]: StateValue<{
        household: boolean;
        business: boolean;
    }>;
    [ChangeNames.MODIFICATION_HOUSING_UNITS]: StateValue<HousingUnits>;
    [ChangeNames.MODIFICATION_GAS_RELOCATION_DISTANCE]: StateValue<BoxedDemandValue>;

    [ChangeNames.MODIFICATION_POWER_CABLE]: StateValue<{
        junctionBoxRelocation: boolean;
        junctionBoxAndCableRelocation: boolean;
        cableRelocation: boolean;
        junctionBoxReplacement: boolean;
    }>;

    [ChangeNames.MODIFICATION_POWER_CABLE_RELOCATION_DISTANCE]: StateValue<BoxedDemandValue>;

    [ChangeNames.MODIFICATION_POWER_JUNCTION_BOX_REPLACEMENT_REASON]: StateValue<{
        defect: boolean;
        other: boolean;
    }>;

    [ChangeNames.MODIFICATION_POWER_CABLE_JUNCTION_BOX_RELOCATION_DISTANCE]: StateValue<BoxedDemandValue>;

    [ChangeNames.MODIFICATION_POWER_FEEDS]: StateValue<{
        cable: boolean;
        overhead: boolean;
    }>;
    [ChangeNames.MODIFICATION_ELECTRIC_BUSINESS_DEMAND]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.MODIFICATION_POWER_OVERHEAD]: StateValue<{
        junctionBoxReplacement: boolean;
        roofPillarReassembly: boolean;
        roofPillarElevation: boolean;
    }>;
    [ChangeNames.MODIFICATION_POWER_OVERHEAD_ROOF_PILLAR_REASSEMBLY_LOCATION]: StateValue<{
        other: boolean;
        same: boolean;
    }>;
    [ChangeNames.MODIFICATION_REASON]: StateValue<StringBox>;

    [ChangeNames.NEW_CONNECTION_BUILDING_INTAKES]: StateValue<{
        outerWall: boolean;
        basePlate: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_BUILDING_TYPES]: StateValue<{
        existing: boolean;
        new: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_BUILDING_USAGES]: StateValue<{
        household: boolean;
        business: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_CELLAR]: StateValue<YesNo>;
    [ChangeNames.MODIFICATION_CELLAR]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_BOILER]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_BUSINESS_DEMAND]: StateValue<BoxedDemandValue>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_ELEVATOR]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_HEAT_PUMP]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_HEAT_PUMP_V2]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM_V2]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_ROOM_COOLING_DEVICE]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_INFEED]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_LOADER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_LOADER_V2]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_SHARED_ELECTRICITY]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_SAUNA]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_ELECTRIC_MISCELLANEOUS]: StateValue<{
        installed: boolean;
        description: string | null;
        demand: DemandValue;
    }>;
    [ChangeNames.NEW_CONNECTION_EXTERIOR_TYPES]: StateValue<{
        connectionPillar: boolean;
        connectionPillarWithMeter: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_GAS_FEEDS]: StateValue<{
        exterior: boolean;
        interior: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_GAS_DEMAND]: StateValue<BoxedDemandValue>;
    [ChangeNames.NEW_CONNECTION_HOUSING_UNITS]: StateValue<HousingUnits>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_BASE_PLATE_HEIGHT]: StateValue<BoxedDemandValue>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_BUILDING_INTAKE_SPECIFICATION]: StateValue<StringBox>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_CASING_PIPE_DELIVERED_BY_DISTRIBUTION_SYSTEM_OPERATOR]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR]: StateValue<YesNo>;
    [ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING]: StateValue<YesNo>;
    [ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL]: StateValue<{
        wallThickness: StateValue<DemandValue>;
        sealing: StateValue<boolean | null>;
        characteristics: StateValue<{
            walled: boolean;
            doubleWall: boolean;
            whiteTub: boolean;
        }>;
        doubleWallSealingLayer: StateValue<{
            concrete: boolean;
            exteriorFormwork: boolean;
            onOuterWall: boolean;
        } | null>;
        doubleWallInteriorInsulation: StateValue<boolean | null>;
    }>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL_BUSHING]: StateValue<{
        casingPipe: boolean;
        coreDrilling: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_CONTACT_ALLOWED]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_DESIRES]: StateValue<{
        yes: boolean;
        no: boolean;
        thirdParty: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_VARIANTS]: StateValue<{
        lines: StateValue<{
            power: boolean;
            water: boolean;
            cistern: boolean;
            gas: boolean;
            multimedia: boolean;
            heatPump: boolean;
            outdoorLighting: boolean;
        }>;
        additionalLines: StateValue<string | null>;
        waterPipeDiameters: StateValue<{
            lessOrEqualDa50: boolean;
            da63: boolean;
        } | null>;
    }>;
    [ChangeNames.NEW_CONNECTION_POWER_FEEDS]: StateValue<{
        exterior: boolean;
        interior: boolean;
        overhead: boolean;
    }>;
    [ChangeNames.NEW_CONNECTION_ROOF_TYPES]: StateValue<{
        flat: boolean;
        metal: boolean;
        other: boolean;
    }>;

    [ChangeNames.REMOVAL_RECONSTRUCTION_BUILDING_USAGES]: StateValue<{
        household: boolean;
        business: boolean;
    }>;
    [ChangeNames.REMOVAL_BUILDING_OCCUPATION_CONFIRMATION]: StateValue<YesNo>;
    [ChangeNames.REMOVAL_POWER_SUBJECT]: StateValue<{
        cableDisassembly: boolean;
        roofPillarDisassembly: boolean;
    }>;
    [ChangeNames.REMOVAL_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK]: StateValue<YesNo>;
    [ChangeNames.REMOVAL_RECONSTRUCTION]: StateValue<YesNo>;
    [ChangeNames.REMOVAL_RECONSTRUCTION_PRODUCT_CLASSES]: StateValue<{
        power: boolean;
        gas: boolean;
    }>;
    [ChangeNames.REMOVAL_DATE]: StateValue<{
        from: number | null;
        to: number | null;
    } | null>;
    [ChangeNames.REMOVAL_RECONSTRUCTION_DATE]: StateValue<{
        from: number | null;
        to: number | null;
    } | null>;
    [ChangeNames.REMOVAL_RECONSTRUCTION_HOUSING_UNITS]: StateValue<HousingUnits>;

    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_UNDERGROUND_WORK]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_WALL_BUSHING]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_OWN_INSTALLATION_FRAME]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_PROVIDED_INSTALLATION_FRAME]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INSTALL_CASING_PIPE]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_MUST_DO_BASE_PLATE_BUSHING]: StateValue<YesNo>;
    [ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_BASE_PLATE_BUSHING]: StateValue<YesNo>;

    [ChangeNames.CHARGER_LOCATION]: StateValue<{
        publicParkingGround: boolean;
        privateParkingGround: boolean;
    }>;
    [ChangeNames.CHARGER_PUBLIC_PARKING_USAGES]: StateValue<{
        allDay: boolean;
        whenOpen: boolean;
    }>;
    [ChangeNames.CHARGER_PRIVATE_PARKING_USAGES]: StateValue<{
        private: boolean;
        employee: boolean;
    }>;
    [ChangeNames.CHARGER_SUPPLY_CONNECTION]: StateValue<{
        new: boolean;
        existing: boolean;
    }>;
    [ChangeNames.CHARGER_CONNECTION_EXTERIOR_TYPE]: StateValue<{
        connectionPillar: boolean;
        connectionPillarWithMeter: boolean;
        chargerPillar: boolean;
    }>;
    [ChangeNames.CHARGER_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR]: StateValue<YesNo>;
    [ChangeNames.CHARGER_ADDITIONAL_ELECTRIC_DEMAND]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK]: StateValue<YesNo>;
    [ChangeNames.ADJUSTABLE_LOAD_BUILDING_USAGE]: StateValue<{
        household: boolean;
        business: boolean;
    }>;
    [ChangeNames.CHARGER_BUILDING_USAGE]: StateValue<{
        household: boolean;
        business: boolean;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_HOUSING_UNITS]: StateValue<HousingUnits>;
    [ChangeNames.CHARGER_HOUSING_UNITS]: StateValue<HousingUnits>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BUSINESS_DEMAND]: StateValue<BoxedDemandValue>;
    [ChangeNames.CHARGER_ELECTRICAL_BUSINESS_DEMAND]: StateValue<BoxedDemandValue>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BOILER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRICAL_BOILER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_HEAT_PUMP]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRICAL_HEAT_PUMP]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_ELEVATOR]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRICAL_ELEVATOR]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_LOADER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRIC_LOADER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SHARED_ELECTRICITY]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRIC_SHARED_ELECTRICITY]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SAUNA]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRIC_SAUNA]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_MISCELLANEOUS]: StateValue<{
        installed: boolean;
        description: string | null;
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRIC_MISCELLANEOUS]: StateValue<{
        installed: boolean;
        description: string | null;
        demand: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_HOUSE_CONNECTION_FUSE_CAPACITY]: StateValue<{
        installed: boolean;
        current: DemandValue;
    }>;
    [ChangeNames.CHARGER_HOUSE_CONNECTION_FUSE_CAPACITY]: StateValue<{
        installed: boolean;
        current: DemandValue;
    }>;
    [ChangeNames.ADJUSTABLE_LOAD_DATA_SHEET_DOWNLOAD]: StateValue<{}>;
    [ChangeNames.CHARGER_CHARGING_STATIONS]: StateValue<
        {
            count: number;
            chargingPoints: StateValue<DemandValue>[];
        }[]
    >;
    [ChangeNames.CHARGER_LOAD_MANAGEMENT]: StateValue<{
        loadManagement: {
            dynamic: boolean;
            static: boolean;
        };
        demand: DemandValue;
    }>;
    [ChangeNames.CHARGER_ELECTRIC_INSTALLATION_AGREEMENT]: StateValue<YesNo>;
    [ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_INSTALLATION_AGREEMENT]: StateValue<YesNo>;
    [ChangeNames.INCREASE_BUILDING_USAGES]: StateValue<{
        household: boolean;
        business: boolean;
    }>;
    [ChangeNames.INCREASE_CURRENT_HOUSING_UNITS]: StateValue<HousingUnits>;
    [ChangeNames.INCREASE_CURRENT_ELECTRIC_BUSINESS_DEMAND]: StateValue<BoxedAndKnowableDemandValue>;
    [ChangeNames.INCREASE_CURRENT_ELECTRIC_BOILER]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_CURRENT_ELECTRIC_HEAT_PUMP]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_CURRENT_ELECTRIC_ELEVATOR]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_CURRENT_ELECTRIC_LOADER]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_CURRENT_ELECTRIC_SHARED_ELECTRICITY]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_CURRENT_ELECTRIC_SAUNA]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_CURRENT_ELECTRIC_MISCELLANEOUS]: StateValue<{
        installed: boolean;
        notKnown: boolean;
        description: string | null;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_CURRENT_GAS_DEMAND]: StateValue<BoxedAndKnowableDemandValue>;
    [ChangeNames.INCREASE_CURRENT_HOUSE_CONNECTION_FUSE_CAPACITY]: StateValue<{
        installed: boolean;
        current: DemandValue;
    }>;

    [ChangeNames.INCREASE_EXPECTED_GAS_DEMAND]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_HOUSING_UNITS]: StateValue<InstalledHousingUnits>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_BUSINESS_DEMAND]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_BOILER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEATING_SYSTEM]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP_V2]: StateValue<YesNo>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_ROOM_COOLING_DEVICE]: StateValue<YesNo>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_ELEVATOR]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_LOADER]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_LOADER_V2]: StateValue<YesNo>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_SHARED_ELECTRICITY]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_SAUNA]: StateValue<{
        installed: boolean;
        demand: DemandValue;
    }>;

    [ChangeNames.INCREASE_EXPECTED_ELECTRIC_MISCELLANEOUS]: StateValue<{
        installed: boolean;
        description: string | null;
        demand: DemandValue;
    }>;
    [ChangeNames.INCREASE_ADDITIONAL_NOTES]: StateValue<StringBox>;

    [ChangeNames.DATA_PROTECTION_AGREEMENT]: StateValue<YesNo>;
    [ChangeNames.TERMS_OF_USE_AGREEMENT]: StateValue<YesNo>;
    [ChangeNames.ADJUSTABLE_LOAD_AGREEMENT]: StateValue<YesNo>;
};

export type ConfigurationState<T extends keyof ChangeTypes = keyof ChangeTypes> = {
    [key in T]?: Change<key>;
};

export type Configuration = {
    id?: string;
    state: ConfigurationState;
    documents: DocumentCollection;
    createdAt: number;
    complete: boolean;
    lockedAt?: number;
    updatedAt?: number;
    error?: string;
    refreshedAt?: number;
    schemaVersion?: string;
};

export type Unwrapped<T> = T extends StateValue<infer A>
    ? A extends DemandValue
        ? DemandValue["amount"]
        : A extends BoxedDemandValue
        ? BoxedDemandValue["amount"]
        : A extends BoxedAndKnowableDemandValue
        ? BoxedAndKnowableDemandValue["amount"]
        : A extends object
        ? {
              [K in keyof A]: Unwrapped<A[K]>;
          }
        : A
    : T extends DemandValue
    ? DemandValue["amount"]
    : T extends BoxedDemandValue
    ? BoxedDemandValue["amount"]
    : T extends BoxedAndKnowableDemandValue
    ? BoxedAndKnowableDemandValue["amount"]
    : T extends object
    ? {
          [K in keyof T]: Unwrapped<T[K]>;
      }
    : T;

export function unwrap<T>(value: StateValue<T>): T;
export function unwrap<T extends BoxedDemandValue>(value: T): Unwrapped<T>;
export function unwrap<T extends DemandValue>(value: T): Unwrapped<T>;
export function unwrap<T extends object>(value: T): Unwrapped<T>;
export function unwrap<T extends any>(value: T): any {
    if (isStateValue(value)) {
        return unwrap(value.value);
    } else if (isBoxedAndKnowableDemandValue(value)) {
        return { ...value.amount, notKnown: value.notKnown };
    } else if (isBoxedDemandValue(value)) {
        return value.amount;
    } else if (isDemandValue(value)) {
        return value.amount;
    } else if (value && Array.isArray(value)) {
        return value.map((v: any) => unwrap(v));
    } else if (value && typeof value === "object") {
        const result: any = {};
        const w = Object.keys(value as {}) as Array<keyof T>;
        for (const a in w) {
            if (!value[w[a]]) {
                result[w[a]] = value[w[a]];
            } else {
                result[w[a]] = unwrap(value[w[a]] as any);
            }
        }
        return result;
    } else {
        return value;
    }
}

export type UnwrappedChange<T extends Change<keyof ChangeTypes>> = Unwrapped<T>;

export function unwrapChange<T extends Change<keyof ChangeTypes>>(change: T): UnwrappedChange<T> {
    return {
        default: change.default,
        relevant: change.relevant,
        state: unwrap(change.state),
    } as UnwrappedChange<T>;
}

export type FormModel<T extends keyof ChangeTypes> = {
    [key in T]: ChangeTypes[key];
};
export const changesToFormModel = <T extends keyof ChangeTypes>(
    changes: ConfigurationState<T>,
): FormModel<T> => {
    const result: Record<string, any> = {};
    Object.entries(changes).forEach(([name, state]: [string, any]) => {
        result[name] = state.state;
    });
    return result as FormModel<T>;
};

export type ChangeSet<T extends keyof ChangeTypes> = {
    [key in T]?: Unwrapped<ChangeTypes[key]>;
};
export const formModelToChangeSet = <T extends keyof ChangeTypes>(
    formModel: FormModel<T>,
): ChangeSet<T> => {
    const result: Partial<Record<keyof ChangeTypes, any>> = {};
    for (const key in formModel) {
        if (Object.prototype.hasOwnProperty.call(formModel, key)) {
            const change = formModel[key];
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            result[key] = unwrap(change!);
        }
    }
    return result;
};

export enum OperationState {
    SUCCEEDED = "SUCCEEDED",
    VALIDATION_FAILED = "VALIDATION_FAILED",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
export type OperationResult<T> = {
    status: OperationState;
    result?: T;
};
